import script from "./ProductListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductListView.vue?vue&type=script&setup=true&lang=ts"

import "./ProductListView.vue?vue&type=style&index=0&id=1f2ca909&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2ca909"]])

export default __exports__